import * as mock from './mock'
import { GetTypeDeclarations } from './types'

export const getTypeDeclarations: GetTypeDeclarations = mock.getTypeDeclarations
